import React, {
    createContext, useEffect, useReducer, useState,
} from "react";
import calculatePrice from "services/patio-calculator";

const initialAttributes = {
    _customProduct: "Yes",
    __basePrice: "",
};

const patioLogic = (state, action) => ({
    ...state,
    ...action,
});

export const PatioContext = createContext(null);

const usePatioCalculator = (
    product = null,
    variant = null,
    parameters = {},
    customizations = [],
    initialConfiguration = {},
    initialCustomAttributes = {}
) => {
    const [configuration, updateConfiguration] = useReducer(patioLogic, {
        product,
        variant,
        amount: 1,
        ...parameters,
        customization_variant_ids: customizations,
        ...initialConfiguration,
    });

    const [customAttributes, setCustomAttributes] = useState({
        ...initialAttributes,
        ...initialCustomAttributes,
    });

    const [activeCoordinate, setActiveCoordinate] = useState(null);

    const [priceData, setPriceData] = useState(null);
    const [loading, setLoading] = useState(false);

    const fetchPrice = async () => {
        setLoading(true);
        const data = await calculatePrice(configuration);
        setLoading(false);

        setCustomAttributes((prevAttributes) => ({
            ...prevAttributes,
            __basePrice: data?.basePrice?.toString(),
            totalPrice: data?.totalPrice?.toString(),
            _squareFeet: data?.totalSqft,
            ...configuration,
        }));
        return data;
    };

    const updatePrice = async () => {
        setPriceData(await fetchPrice());
    };

    useEffect(() => {
        (async () => {
            await updatePrice();
        })();
    }, [configuration]);

    return {
        configuration,
        updateConfiguration,
        updatePrice,
        priceData,
        customAttributes,
        setCustomAttributes,
        activeCoordinate,
        setActiveCoordinate,
        loading,
    };
};

const PatioCalculator = ({
    product,
    variant,
    children,
    parameters,
    customizations,
    initialConfiguration,
    initialCustomAttributes,
}) => {
    const calculator = usePatioCalculator(
        product,
        variant,
        parameters,
        customizations,
        initialConfiguration,
        initialCustomAttributes
    );

    return (
        <PatioContext.Provider value={calculator}>
            {children}
        </PatioContext.Provider>
    );
};

export default PatioCalculator;
